<script lang="ts">
	import type { ProductForCustomer } from "../../../../core/schema/Product.js";
	import type { ProductSize } from "../../../../core/schema/ProductSize.js";
	import { productSizeKeyMap } from "../../../../core/schema/productSizeKeyMap.js";
	import type { CategorySeoPage } from "../../../../core/schema/CategorySeoPage.js";
	import { ProductOption } from "../../../../core/schema/ProductOption.js";
	import { isEnum } from "../../../../core/utils/enum/isEnum.js";
	import ProductSizeInput from "./ProductSizeInput.svelte";
	import Tooltip from "../Tooltip.svelte";
	import { nbspify } from "../../../../core/utils/nbspify.js";
	import { createEventDispatcher } from "svelte";

	export let selectedSize: ProductSize;
	export let product: ProductForCustomer;
	export let isExpress: boolean;
	export let isSizeAddedToCart = false;
	export let activeFilter: CategorySeoPage["type"] | undefined = undefined;

	const dispatch = createEventDispatcher();

	function handleSizeChange(): void {
		dispatch("sizechange");
	}

	const heightClasses = ["h-[1.5rem]", "h-[1.625rem]", "h-[1.75rem]", "h-[2rem]"];

	const availableSizes = product.availableSizes.filter(
		(size) => !isExpress || product.warehouseCounts?.[size] !== undefined,
	);

	/* eslint-disable @typescript-eslint/explicit-function-return-type */
</script>

<div class="flex flex-row flex-wrap items-end gap-x-2 gap-y-1">
	{#each availableSizes as size, index}
		{@const heightClass = heightClasses[index]}
		{@const availableWithOption =
			!isEnum(ProductOption)(activeFilter) || product.enabledOptions[productSizeKeyMap[size]].includes(activeFilter)}

		{#if !availableWithOption}
			<Tooltip>
				<ProductSizeInput
					{availableWithOption}
					{isSizeAddedToCart}
					{product}
					bind:selectedSize
					{size}
					class={heightClass}
					on:change={handleSizeChange}
				/>

				<div slot="tooltip">
					{nbspify("Produkt s filtrovaným příplatkem se v této velikosti nevyrábí.")}
				</div>
			</Tooltip>
		{:else}
			<ProductSizeInput
				{availableWithOption}
				{isSizeAddedToCart}
				{product}
				{size}
				bind:selectedSize
				class={heightClass}
				on:change={handleSizeChange}
			/>
		{/if}
	{/each}
</div>
